module.exports = __webpack_public_path__ + "img/fond-menu.80dddbea.jpg";